import { useReducer } from "react";

const initialState = {
  error: null,
  loader: { isLoading: true },
  success: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOADED":
      return {
        ...state,
        loader: { isLoading: false },
      };
    case "LOADING":
      return {
        ...state,
        loader: {
          isLoading: true,
          secondaryText: action.payload,
        },
      };
    case "SUCCESS":
      return {
        ...state,
        loader: { isLoading: false },
        success: true,
      };
    case "ERROR":
      return {
        ...state,
        error: action.payload,
        loader: { isLoading: false },
      };
    default:
      return state;
  }
};

export const usePageReducer = () => {
  const [store, dispatch] = useReducer(reducer, initialState);
  return [store, dispatch];
};
